export default "__VITE_ASSET__Bqiba6Wr__"